import { useState, useEffect } from 'react';

export function useModal() {
  const [isOpen, setIsOpen] = useState(false);
  const [icon, setIcon] = useState('🔖');

  const open = (iconChar) => {
    if (iconChar) setIcon(iconChar);
    setIsOpen(true);
  };

  const close = () => setIsOpen(false);

  useEffect(() => {
    const handleKey = (e) => { if (e.key === 'Escape') close(); };
    document.addEventListener('keydown', handleKey);
    return () => document.removeEventListener('keydown', handleKey);
  }, []);

  useEffect(() => {
    document.body.style.overflow = isOpen ? 'hidden' : '';
    return () => { document.body.style.overflow = ''; };
  }, [isOpen]);

  return { isOpen, icon, open, close };
}
